<template>
  <b-row>
    <b-col cols="12" md class="mb-3 m-md-0">
      <b-input autocomplete="off" class="form-control-gray" placeholder="Search kudos" @input="onQuery" />
    </b-col>
    <b-col cols="12" md="4">
      <b-dropdown block variant="outline" class="dropdown-select">
        <template #button-content>
          <span v-html="selected" />
        </template>
        <b-dropdown-item-button v-for="option in options" :key="option.id" @click="onTypeClick(option.id)">
          <span v-html="option.html" />
        </b-dropdown-item-button>
      </b-dropdown>
    </b-col>
  </b-row>
</template>

<script>
import { KUDO_SELECT_TYPE } from '@/helpers/types'

export default {
  name: 'KudosSearch',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: Object,
      default: () => ({
        query: '',
        type: KUDO_SELECT_TYPE.ALL
      })
    },

    external: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    selected() {
      const option = this.options.find(p => p.id === this.value.type)
      return option ? option.html : ''
    },

    options() {
      const options = []

      options.push({ id: KUDO_SELECT_TYPE.ALL, html: 'All kudos' })
      if (!this.external) {
        options.push({ id: KUDO_SELECT_TYPE.RECEIVED, html: 'Kudos I received' })
      }
      options.push({ id: KUDO_SELECT_TYPE.BEHAVIORS, html: '<span class="color-darkteal">Soft skills</span> (behaviors)' })
      options.push({ id: KUDO_SELECT_TYPE.EXPERTISE, html: '<span class="color-blue">Technical skills</span> (expertise)' })

      return options
    }
  },

  // data() {
  //   return {
  //     options: [
  //       { id: KUDO_SELECT_TYPE.ALL, html: 'All kudos' },
  //       { id: KUDO_SELECT_TYPE.RECEIVED, html: 'Kudos I received' },
  //       { id: KUDO_SELECT_TYPE.BEHAVIORS, html: '<span class="color-darkteal">Soft skills</span> (behaviors)' },
  //       { id: KUDO_SELECT_TYPE.EXPERTISE, html: '<span class="color-blue">Technical skills</span> (expertise)' }
  //     ]
  //   }
  // },

  methods: {
    onQuery(query) {
      this.$emit('change', { ...this.value, query: query })
    },

    onTypeClick(type) {
      this.$emit('change', { ...this.value, type: type })
    }
  }
}
</script>
